// Importaciones de componentes MDX

import MDX_2025_07_20_1_19 from '@/changelog/2025-07-20-1-19.mdx'
import MDX_2025_07_23_1_20 from '@/changelog/2025-07-23-1-20.mdx'
import MDX_2025_08_04_1_21 from '@/changelog/2025-08-04-1-21.mdx'
import MDX_2025_09_09_1_22 from '@/changelog/2025-09-09-1-22.mdx'
import MDX_2025_09_29_1_24 from '@/changelog/2025-09-29-1-24.mdx'
import MDX_2025_11_14_1_26 from '@/changelog/2025-11-14-1-26.mdx'
import MDX_2026_04_06_1_27 from '@/changelog/2026-04-06-1-27.mdx'
import MDX_2026_07_13_1_28 from '@/changelog/2026-07-13-1-28.mdx'
import MDX_2026_09_30_1_29 from '@/changelog/2026-09-30-1-29.mdx'
import { FEATURES } from '@/shared/config/features'

export interface ChangelogEntry {
  title: string
  date: string
  version?: string
  tags?: string[]
  description?: string
  body: React.ComponentType
}

export interface ChangelogConfig {
  url: string
  filename: string
  data: ChangelogEntry
}

// Configuración centralizada de todos los changelog
// Para agregar un nuevo changelog:
// 1. Crea el archivo .mdx en la carpeta /src/changelog/
// 2. Importa el componente arriba
// 3. Agrega una nueva entrada en este array
export const CHANGELOG_ENTRIES: ChangelogConfig[] = [
  {
    url: '/changelog/2026-09-30',
    filename: '2026-09-30',
    data: {
      title: 'Créditos',
      date: '2026-09-30',
      version: '1.29.0',
      tags: ['Feature', 'Créditos', 'Postventa', 'Avisos'],
      description:
        'Nuevo módulo de Créditos: el expediente de financiamiento paso a paso, avisos automáticos al cliente y al equipo, bitácora completa y el traspaso a Postventa cuando el crédito se aprueba.',
      body: MDX_2026_09_30_1_29
    }
  },
  // El Portal del Cliente todavía no está liberado, así que su entrada no se publica: anunciar una
  // función que el usuario no puede usar es peor que no anunciarla. Va detrás del MISMO flag que la
  // función, para que se publique sola el día que se libere en vez de depender de que alguien se
  // acuerde de descomentarla.
  ...(FEATURES.clientPortal
    ? [
        {
          url: '/changelog/2026-07-13',
          filename: '2026-07-13',
          data: {
            title: 'Portal del Cliente y Revalidación Anual',
            date: '2026-07-13',
            version: '1.28.0',
            tags: ['Feature', 'Portal del Cliente', 'Clientes', 'Revalidación', 'Permisos'],
            description:
              'Nuevo Portal del Cliente para recopilar, revisar y revalidar expedientes con formularios autogestionados, documentos, correcciones, trazabilidad y permisos específicos por rol.',
            body: MDX_2026_07_13_1_28
          }
        }
      ]
    : []),
  {
    url: '/changelog/2026-04-06',
    filename: '2026-04-06',
    data: {
      title: 'Inventario y Documentos de Aprobaciones',
      date: '2026-04-06',
      version: '1.27.0',
      tags: ['Feature', 'Inventario', 'Aprobaciones', 'Documentos', 'Negociaciones'],
      description:
        'Nuevo módulo de Inventario para gestión de disponibilidad y reservas, y nuevo sistema de Documentos de Aprobaciones con flujos de revisión multi-participante dentro de negociaciones.',
      body: MDX_2026_04_06_1_27
    }
  },
  {
    url: '/changelog/2025-11-14',
    filename: '2025-11-14',
    data: {
      title: 'Edición de Contrato Promesa',
      date: '2025-11-14',
      version: '1.26.0',
      tags: ['Feature', 'Contratos', 'Promesa', 'Documentos', 'Editor'],
      description:
        'Editor enriquecido para contratos de promesa con bloques de comparecencia y fe notarial. Permite editar y personalizar el documento antes de generar el PDF final.',
      body: MDX_2025_11_14_1_26
    }
  },
  {
    url: '/changelog/2025-09-29',
    filename: '2025-09-29',
    data: {
      title: 'Sistema de Adjuntos Obligatorios/Opcionales',
      date: '2025-09-29',
      version: '1.24.0',
      tags: ['Feature', 'Adjuntos', 'Workflow', 'Documentos', 'UX'],
      description:
        'Sistema completo de gestión de adjuntos obligatorios y opcionales vinculados a estados de negociación y clientes, con validación de tipos de archivo y control de acceso según el estado del flujo de trabajo.',
      body: MDX_2025_09_29_1_24
    }
  },
  {
    url: '/changelog/2025-09-09',
    filename: '2025-09-09',
    data: {
      title: 'Módulo de Postventa y Sistema de Permisos Avanzado',
      date: '2025-09-09',
      version: '1.22.0',
      tags: ['Postventa', 'Permisos', 'Seguridad', 'Módulo', 'UX'],
      description:
        'Introducción del nuevo módulo completo de postventa con gestión de propiedades, sistema de permisos granular y mejoras significativas en la experiencia de usuario.',
      body: MDX_2025_09_09_1_22
    }
  },
  {
    url: '/changelog/2025-08-04',
    filename: '2025-08-04',
    data: {
      title: 'Dashboard Renovado, Órdenes de Producción y Rescisión Extendida',
      date: '2025-08-04',
      version: '1.21.0',
      tags: ['Dashboard', 'Órdenes de Producción', 'UX', 'Rescisión', 'Métricas'],
      description:
        'Nueva experiencia de dashboard con métricas en tiempo real, reestructuración del sistema de órdenes de producción y funcionalidad para rescindir negociaciones en estado aprobado.',
      body: MDX_2025_08_04_1_21
    }
  },
  {
    url: '/changelog/2025-07-20',
    filename: '2025-07-20',
    data: {
      title: 'Sistema "What\'s New"',
      date: '2025-07-20',
      version: '1.19.0',
      tags: ["What's New", 'Changelog', 'UX', 'Modal', 'Versiones'],
      description:
        'Implementación del sistema "What\'s New" con modal emergente, página dedicada de changelog y gestión de versiones para mantener informados a los usuarios sobre los cambios en la plataforma.',
      body: MDX_2025_07_20_1_19
    }
  },
  {
    url: '/changelog/2025-07-23',
    filename: '2025-07-23',
    data: {
      title: 'Motor de Plantillas de Contratos',
      date: '2025-07-23',
      version: '1.20.0',
      tags: ['Plantillas', 'Contratos', 'Editor', 'PDF', 'Variables'],
      description:
        'Introducción del sistema de plantillas de contratos con editor de bloques avanzado, gestión de variables dinámicas y generación automática de PDFs.',
      body: MDX_2025_07_23_1_20
    }
  }
]

// Función helper para obtener changelog ordenados por fecha
export function getSortedChangelogs(): ChangelogConfig[] {
  return CHANGELOG_ENTRIES.sort((a, b) => {
    const dateA = new Date(a.data.date).getTime()
    const dateB = new Date(b.data.date).getTime()
    return dateB - dateA // Más recientes primero
  })
}

// Función helper para obtener un changelog específico
export function getChangelogByFilename(filename: string): ChangelogConfig | undefined {
  return CHANGELOG_ENTRIES.find((entry) => entry.filename === filename)
}
